import { configureStore } from '@reduxjs/toolkit';
import { authApi } from '../features/auth/api/authApi';
import { userApi } from '../features/user/api/userApi';
import { constructorApi } from '../features/constructor/api/constructorApi';
import { mediaApi } from '../features/media/api/mediaApi';
import { miniappApi } from '../features/miniapp/api/miniappApi';
import { supportApi } from '../features/support/api/supportApi';
import { botsApi } from '../features/bots/api/botsApi';
import { paymentsApi } from '../features/payments/api/paymentsApi';
import { tariffsApi } from '../features/tariffs/api/tariffsApi';
import { channelsApi } from '../features/channels/api/channelsApi';
import authReducer from './store/authSlice';
import userReducer from './store/userSlice'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        [authApi.reducerPath]: authApi.reducer,
        user: userReducer,
        [userApi.reducerPath]: userApi.reducer,
        [constructorApi.reducerPath]: constructorApi.reducer,
        [mediaApi.reducerPath]: mediaApi.reducer,
        [miniappApi.reducerPath]: miniappApi.reducer,
        [supportApi.reducerPath]: supportApi.reducer,
        [botsApi.reducerPath]: botsApi.reducer,
        [paymentsApi.reducerPath]: paymentsApi.reducer,
        [channelsApi.reducerPath]: channelsApi.reducer,
        [tariffsApi.reducerPath]: tariffsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            authApi.middleware,
            userApi.middleware,
            constructorApi.middleware,
            mediaApi.middleware,
            miniappApi.middleware,
            supportApi.middleware,
            botsApi.middleware,
            paymentsApi.middleware,
            channelsApi.middleware,
            tariffsApi.middleware,
        ),
});

export default store;
